export default abstract class PreUndoData {

}